import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ArrowUp = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="arrow-up"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 25 15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.2624 0.53968L0.513102 11.8543C-0.171036 12.5741 -0.171036 13.741 0.513102 14.4604C1.19663 15.1799 2.30524 15.1799 2.98872 14.4604L12.5002 4.4487L22.0113 14.4601C22.6951 15.1796 23.8036 15.1796 24.4871 14.4601C25.171 13.7407 25.171 12.5738 24.4871 11.854L13.7377 0.539389C13.3958 0.179661 12.9481 -1.47823e-07 12.5002 -1.53317e-07C12.0521 -1.58813e-07 11.6041 0.180011 11.2624 0.53968Z" />
    </svg>
  );
};
/* eslint-enable max-len */

ArrowUp.defaultProps = {
  className: null,
};

ArrowUp.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ArrowUp;
